import React, { FC, useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

interface FloatLabelProps {
  children: React.ReactNode;
  label: string;
  value?: string | number | boolean | string[] | number[];
  className?: string;
  onGray?: boolean;
  noBorderRadius?: boolean;
}

const FloatLabel: FC<FloatLabelProps> = ({ children, label, value, className, onGray, noBorderRadius }) => {
  const [focus, setFocus] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    setHasValue(Boolean(value && String(value).trim().length > 0));
  }, [value]);

  const handleFocus = () => {
    setFocus(true);
  };

  const handleBlur = () => {
    setFocus(false);
  };

  return (
    <div
      className={cn(styles.floatingLabelContainer, className, {
        [styles.gray]: onGray,
        [styles.noBorderRadius]: noBorderRadius
      })}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {children}
      <label
        className={cn(styles.label, {
          [styles.float]: focus || hasValue
        })}
      >
        {label}
      </label>
    </div>
  );
};

export default FloatLabel;